module.exports = __webpack_public_path__ + "static/analytics-02-min-1287e384d42f237b1d71087efbbd66f0.jpg";